import { MAX_PAGE_SIZE } from "@/constants/pagination";

const DEFAULT_MAX_PAGES = 100;

/**
 * Generic utility to fetch all pages from a paginated API endpoint.
 *
 * @param fetchPage - Callback that fetches a single page given limit and offset.
 *   Must return `{ items, hasMore }`.
 * @param options - Optional overrides for maxPages and pageSize.
 * @returns All items accumulated across pages.
 */
export async function fetchAllPages<T>(
  fetchPage: (limit: number, offset: number) => Promise<{ items: T[]; hasMore: boolean }>,
  options?: { maxPages?: number; pageSize?: number },
): Promise<T[]> {
  const { maxPages = DEFAULT_MAX_PAGES, pageSize = MAX_PAGE_SIZE } = options ?? {};
  const allItems: T[] = [];
  let offset = 0;

  for (let page = 0; page < maxPages; page++) {
    const { items, hasMore } = await fetchPage(pageSize, offset);
    allItems.push(...(items || []));
    if (!hasMore) break;
    offset += pageSize;
  }

  return allItems;
}
